import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAccess, useAccountId } from "../Auth/auth-functions";
import { AzureADRoles } from "../Auth/auth-roles";
import { api } from "./api";
import { AzureADUserDto, AzureAppRoleDto } from "../models/azuread.models";

export const useGetAzureADUsersQuery = () => {
	const hasAccess = useAccess(AzureADRoles.Admin);
	const accountId = useAccountId();

	return useQuery({
		queryKey: ['azuread-users', accountId],
		queryFn: async () => {
			let res = await api.get<AzureADUserDto[]>(`/azure/accounts`);
			return res.data;
		},
		staleTime: 5 * 60 * 1000,
		gcTime: 60 * 1000,
		enabled: hasAccess
	});
}

export const useGetAzureAppRolesQuery = () => {
	const hasAccess = useAccess(AzureADRoles.Admin);
	const accountId = useAccountId();

	return useQuery({
		queryKey: ['azuread-roles', accountId],
		queryFn: async () => {
			let res = await api.get<AzureAppRoleDto[]>(`/azure/roles`);
			return res.data;
		},
		staleTime: 5 * 60 * 1000,
		gcTime: Infinity,
		enabled: hasAccess
	});
}